export default "__VITE_ASSET__cbC14IWo__"